import { render, staticRenderFns } from "./ReservedPerBuyer.vue?vue&type=template&id=696f2b24&"
import script from "./ReservedPerBuyer.vue?vue&type=script&lang=js&"
export * from "./ReservedPerBuyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports